import { gql } from '@apollo/client';

export const DOCUMENT_SIGN_STATE_TRANSITION_DELETED = gql`
  subscription documentSignStateTransitionDeleted {
    documentSignStateTransitionDeleted {
      startStatus
    }
  }
`;

export const DOCUMENT_SIGN_STATE_TRANSITION_UPDATED = gql`
  subscription documentSignStateTransitionUpdated {
    documentSignStateTransitionUpdated {
      startStatus
    }
  }
`;
